import React from 'react';

export default class Subject extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			showDescription: false
		}
	}
	

	getDescriptionBlock() {
		if (this.props.description !== "") {
			if (this.state.showDescription) {
				return (
					<div style={{"marginTop": "10px"}} className="well well-sm no-margin-bottom">
						<button style={{"paddingTop": 0}} className="btn btn-link center-block" type="button" onClick={ () => this.setState({ showDescription: false }) }>Beschreibung verbergen</button>
						<p className="text-center" style={{"marginBottom": 0}}>{ this.props.description }</p>
					</div>
				);
			}
			else {
				return ( <button className="btn btn-link center-block no-padding-bottom" type="button" onClick={ () => this.setState({ showDescription: true }) }>Beschreibung anzeigen</button> );
			}
		}
		else {
			return null;
		}
	}

    render(){
		return (
			<div>
				<h4 className="text-center">{ this.props.name }</h4>
				{ /*this.getDescriptionBlock()*/ }
			</div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/user/Subject.js